export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_11.ecc3f118.png";